import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
<footer>
  <div className='footer-container'>
    <div className='footer-name'>
      <h1>RESANIO</h1>
      <p>To nejlepší pro vaše podnikání</p>
    </div>
  <div>
    <div className='footer-links-container'>
    <div className="footer-links">
      <div className='footer-section-name'><h3>Hlavní sekce</h3></div>
      <div><a href="/">Hlavní stránka</a></div>
      <div><a href="/contact">Kontakt</a></div>
      <div><a href="/doc">Dokumentace</a></div>
      <div><a href="/cookiePage">Cookies</a></div>
      <div><a href="/termsAndConditions">Obchodní podmínky</a></div>
      </div>
      <div className="footer-links">
      <div className='footer-section-name'><h3>Pro uživatele</h3></div>
      <div><a href="/login">Přihlášení</a></div>
      <div><a href="/register">Registrace</a></div>
      <div><a href="/profile">Profil</a></div>
      </div>
      <div className="footer-links">
      <div className='footer-section-name'><h3>Pro podnikatele</h3></div>
      <div><a href="/business/login">Přihlášení pro podnikatele</a></div>
      <div><a href="/business/register">Registrace pro podnikatele</a></div>
      <div><a href="/business/profile">Podnikatelský profil</a></div>
    </div>
    </div>
    </div>
    <div className='copyright'><p>&copy; 2025 Martin Šimek. Všechna práva vyhrazena.</p></div>
    </div>
</footer>
  )
}

export default Footer